module.exports = __webpack_public_path__ + "static/media/logo-white.79d6f8ad.png";